import { ApplicationRef, Component, ComponentFactoryResolver, Injector, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, ModalController } from '@ionic/angular';
import { LocaldataService } from '../../service/localdata/localdata.service';
import { RentalagreementPage } from '../forms/rentalagreement/rentalagreement.page';
import { CultivationagreementPage } from '../forms/cultivationagreement/cultivationagreement.page'
import { PrecampaignsubmissionPage } from '../forms/precampaignsubmission/precampaignsubmission.page'
import { RentalagreementCampaingPage } from '../forms/rentalagreement_campaign/rentalagreement.page';
import { ProtamylasseorderPage } from '../forms/protamylasseorder/protamylasseorder.page';
import { PotatoseedorderPage } from '../forms/potatoseedorder/potatoseedorder';

@Component({
  selector: 'app-forms-available',
  templateUrl: './forms-available.page.html',
  styleUrls: ['./forms-available.page.scss'],
})
export class FormsAvailablePage implements OnInit {

  forms: any[];
  private subscription: any;
  private publisher: string;


  /*private tmpFormObj ={
    "isSpecial": false,
    "systemname": "Dyrkningskontrakt 2025/26",
    "displayname": "Udfyld AKD Dyrkningskontrakten for 2025/26",
    "year": "2025-2026",
    "displayDeadline": "20.06.25",
    "displayIcon": "agreement",
    "deadline": "2025-09-01T00:00:00.000Z",
    "component": "CultivationagreementPage",
    "publisher": "AKD",
    "msgDateOutOfRange": "Kontrakten skulle have været udfyldt og indsendt inden den 1. september",
    "msgAlreadySubmitted": "Du har allerede udfyldt kontrakten og den kan kun indsendes én gang.",
    "onceperyear": true,
    "isSoldOut": null,
    "soldOutMsg": null,
    "orderYear": null,
    "tandc": null,
    "formproperties": null,
    "id": 60,
    "factoryId": 105,
    "createdAt": "2022-05-08T15:30:59.509Z",
    "updatedAt": "2022-05-08T15:30:59.509Z",
    "createdBy": 0,
    "updatedBy": null,
    "deletedAt": null,
    "deletedBy": null,
    "factory": {
        "displayname": "AKD",
        "address": {
            "street": "Herningvej 38",
            "zipcode": "7330",
            "city": "Brande"
        },
        "id": 105
    },
    "forms": [],
    "status": "ready"
}*/


  /*private tmpFormObj = {
    "isSpecial": false,
    "systemname": "Bestilling af protamylasse til foråret 2024",
    "displayname": "Bestilling af protamylasse til foråret 2024",
    "year": "2023-2024",
    "displayDeadline": "17.12.24",
    "displayIcon": "protamylasse",
    "deadline": "2024-12-17T00:00:00.000Z",
    "component": "ProtamylasseorderPage",
    "publisher": "AKD",
    "msgDateOutOfRange": null,
    "msgAlreadySubmitted": "",
    "onceperyear": true,
    "isSoldOut": null,
    "soldOutMsg": null,
    "orderYear": null,
    "tandc": null,
    "formproperties": null,
    "id": 57,
    "factoryId": 105,
    "createdAt": "2022-05-08T15:30:59.509Z",
    "updatedAt": "2022-05-08T15:30:59.509Z",
    "createdBy": 0,
    "updatedBy": null,
    "deletedAt": null,
    "deletedBy": null,
    "factory": {
        "displayname": "AKD",
        "address": {
            "street": "Herningvej 38",
            "zipcode": "7330",
            "city": "Brande"
        },
        "id": 105
    },
    "forms": [],
    "status": "ready"
}*/

/*private tmpFormObj = {
  "isSpecial": false,
  "systemname": "Potatoseeds",
  "displayname": "Bestilling af læggekartofler til sæsonen 2025",
  "year": "2023-2024",
  "displayDeadline": "17.12.24",
  "displayIcon": "potatoseed",
  "deadline": "2024-12-17T00:00:00.000Z",
  "component": "PotatoseedorderPage",
  "publisher": "AGRO",
  "msgDateOutOfRange": "Bestillinger skal indleveres senest den 8. januar 2024. Kontakt Kim eller Per fra KMC Agro.",
  "msgAlreadySubmitted": "",
  "onceperyear": true,
  "isSoldOut": null,
  "soldOutMsg": null,
  "orderYear": null,
  "tandc": "<h2>Læggekartofler til foråret 2025 - orientering & betingelser</h2><p><strong>Faste sorter</strong><br/>Til foråret 2025 tilbyder KMC Agro materiale i følgende faste sorter: Allstar, Avarna, Avenue, Kuras, Luneba, Saprodi, Saturna, Seresta, Stratos, Tarzan, Verdi og Ydun.</p><p><strong>Supplerende sorter</strong><br/>Der er desuden mulighed for at bestille mindre mængder i følgende supplerende sorter: Fyone, Lady Rosetta, Nofy, Sarion og Skawa.</p><p>De ­supplerende sorter vil ikke nødvendigvis kunne leveres i alle klasser og mængder. Vi kan derfor ikke garantere, at KMC Agro kan levere ­sorterne i de ønskede klasser og mængder, og vi forbeholder os ret til at ændre klasserne og mængderne.</br>Der kan ikke oplyses pris på de supplerende sorter på bestillingstidspunktet. </p><p><strong>Bliv klogere på sorterne på Sortsinfo</strong><br/>I Sortsinfo på avlerinfo.dk har vi samlet en række sortsoplysninger om stivelses- og pulversorter, bl.a. om de sorter, som KMC Agro tilbyder. Find detaljerede og opdaterede beskrivelser af sorterne og brug valg- og filterfunktioner til at finde de rigtige sorter – og sammenlign op til 5 sorter ad gangen. <br/>Du finder Sortsinfo direkte her i app’en Avlerinfo Selvbetjening eller på KMC Agros hjemmeside: http://www.avlerinfo.dk/sortsinfo</p><p><strong>Klasse PB</strong><br/>KMC Agro kan – i begrænset omfang – tilbyde kl. PB i visse sorter til foråret 2025. Prisen vil være ca. 500 kr./hkg og leverance er afhængig af, at vi har de fornødne mængder til rådighed. Hvis du ønsker at komme i betragtning til kl. PB kan du skrive det i kommentarfeltet, som bliver vist sidst i bestillingen.</p><p>Det skal understreges, at kl. PB er sidestillet med kl. S, SE og A når materialet anvendes i brugsavlen. ­Materialet må udelukkende anvendes til egen opformering til brugsavl og må ikke sælges videre. </p><p><strong>Klasse S/SE</strong><br/> Klasse S er produceret direkte på klasse PB fra præ­basisavlerne. • For klasse S er kvalitetskravene: 0 % virus Y og bladrulle. • For klasse SE er kvalitetskravene: maks. 1 % virus Y og bladrulle. </p><p>Klasse S skal bestilles senest d. 8. januar 2024. Der tages forbehold for, at der er PB-­materiale til rådighed. <br/>Hvis der ikke kan leveres klasse S, overføres bestillingen til klasse SE.</p><p><strong>Behandling med Diabolo i klasse S, men ikke i klasse SE og A</strong><br/>Læggekartofler i klasse S fra KMC Agros egne fremavlere bliver behandlet med Diabolo imod lagersvamp, mens ­kartofler i klasse SE og A ikke vil blive bejdset med Diabolo. (Diabolo har afløst Fungazil TM 100, og har samme indhold af aktivstoffet imazalil). Andelshaverne skal fortsat selv behandle imod rodfiltsvamp.</p><p><strong>Kvalitetskrav </strong><br/>Landbrugsstyrelsens bekendtgørelse for læggekartofler er gældende. For klasse S og SE gælder desuden KMC Agros ­skærpede krav. For de udleverede sorter vil der efter ønske kunne udleveres et dataark, hvor det er muligt at se ­informationer om marksyn og virustest.</p><p><strong>Leveringsformer</strong><br/>12,5 hkg storsække eller løsleverance. Minimum leverance i storsække er 12,5 hkg. Minimum ved ­løs­leverance er 150 hkg. </p><p><strong>Størrelse</strong><br/>Klasse A, SE og S opsorteres alle i størrelse 35/55 mm.</p><p><strong>Reklamationsfrist</strong><br/>For sækkevarer senest 14 dage fra udleveringsdato, for løsvarer inden kartoflerne læsses af.</p><p><strong>Levering</strong><br/>Den ordinære udkørsel vil starte d. 20. februar 2025 (hvis vejret tillader det) og slutte senest d. 15. april 2025. ­Andels­haverne skal være villige til at modtage kartoflerne i denne periode. <br>Der er mulighed for leverance af Kuras i perioden fra d. 1. februar til d. 20. februar, hvis vejret tillader det. Ved ­leverance i denne periode er ­prisen 5 kr. lavere pr. hkg. Hvis det pga. vejret ikke er muligt at levere inden d. 20. ­februar, vil kartoflerne blive faktureret til normal pris. Du kan vælge tidlig levering af Kuras sidst i bestillingen. </p><p><strong>Videresalg</strong><br/>De udleverede læggekartofler må ikke videresælges uden KMC Agros samtykke.</p><p><strong>Priserne er eksklusiv fragt og moms</strong><br/>Bemærk at priserne er inkl. kartoffelafgift og forædlerafgift, men ­ekskl. fragt og moms.  </p><p><strong>Leveringsforbehold</strong><br/>Er KMC Agro ikke leveringsdygtig i de bestilte sorter, forbeholdes ret til at til­byde at levere en anden sort, eller ­eventuelt at reducere mængden. Lige­ledes forbeholdes ret til, om for­nødent, at ændre leveringstidspunkt og klasse. Der tages forbehold for afgifts­ændringer.</p><p><strong>Løbende ændringer og bindende bestilling</strong><br/>Igen i år kan du løbende ændre og gemme din bestilling på læggekartofler i app’en helt frem til midnat mandag d. 8. januar 2024. Hvis du ændrer din bestilling, vil der automatisk blive genereret en ny opsummering på bestillingen i app’ens digitale dueslag, mens den tidligere opsummering vil blive fjernet. Dvs. at opsummeringen i det digitale dueslag altid afspejler den aktuelle bestilling. Den bestilling der er gemt i Avlerinfo Selvbetjening ved midnat mellem d. 8. og d. 9. januar, bliver automatisk sendt til KMC Agro. <br/><strong>Bemærk at bestillingen er bindende!</strong></p><p><strong>Efterregulering af bestilling</strong><br/>Så vidt det er praktisk muligt for KMC Agro, kan man efterregulere sin bestilling frem til d. 1. februar 2025 – og ikke ­senere end det. Der kan dog altid bestilles ekstra mængder, så længe der er mængder til rådighed.</p><p><strong>Har du spørgsmål?</strong><br/>Hvis du har spørgsmål vedr. bestilling af læggekartofler kan du kontakte Kim Rask Hansen (4064 8819, krh@kmc.dk), Per Thorlund Christensen (5339 1806, ptc@kmc.dk) eller Lasse Primdal (9363 1714, ­lap@kmc.dk).</p><p><strong>Kontraktspart</strong><br/><em>KMC amba. fungerer som administrator for fabrikkerne AKD, Andels-Kartoffelmelsfabrikken Danmark, CVR: 62818328, Karup Kartoffelmelsfabrik, CVR: 16217719 og KMC Granules, CVR: 15230614. Det vil sige, at KMC alene administrerer bestillingsproceduren og faktureringen af læggekartofler på vegne af de nævnte fabrikker. Aftalen om køb og levering af læggekartofler indgås juridisk mellem dig og den ­konkrete fabrik. ­Hvilken fabrik aftalen indgås med afhænger af, hvilken fabrik din dyrkningskontrakt og/eller din ­leveringsaftale indgås med.</em></p><p><strong>Finansiering</strong><br/><em>Faktura på læggekartoflerne udsendes af KMC på vegne af en af kartoffelmelsfabrikkerne. Man kan enten betale fakturaen eller finansiere læggekartoflerne gennem den fabrik man er tilknyttet. Ønsker man at betale fakturaen skal dette ske til fabrikken og ikke til KMC. Ønskes finansieringen gennem fabrikken vil det skyldige beløb inkl. renter og evt. omkostninger blive modregnet i betalingen for dine kartoffelleverancer til henholdsvis stivelse/granules.<em></p>",
  "formproperties": {"year":"2025","potatoseedyear":"2024-2025", "header":"til sæsonen 2025", "deadline":"Husk at du kan rette i din bestilling frem til 8. januar 2024", "kuras":"Jeg ønsker de bestilte partier i Kuras leveret i perioden fra d. 1. februar 2025 til d. 20. februar 2025 hvis vejrliget tillader det. Se i øvrigt orientering og betingelser i følgebrevet.", "deadline_confirmation":"Bemærk at du kan opdatere din bestilling frem til midnat den 8. januar 2024."},
  "id": 1001,
  "factoryId": 105,
  "createdAt": "2022-05-08T15:30:59.509Z",
  "updatedAt": "2022-05-08T15:30:59.509Z",
  "createdBy": 0,
  "updatedBy": null,
  "deletedAt": null,
  "deletedBy": null,
  "factory": {
      "displayname": "AKD",
      "address": {
          "street": "Herningvej 38",
          "zipcode": "7330",
          "city": "Brande"
      },
      "id": 105
  },
  "forms": [],
  "status": "ready"
}*/



  constructor(private localData: LocaldataService, private route: ActivatedRoute, private modalCtrl: ModalController, private alertCtrl: AlertController, private router: Router, private viewContainerRef: ViewContainerRef, private appRef: ApplicationRef, private componentFactoryResolver: ComponentFactoryResolver, private injector: Injector) {}


  ionViewDidEnter() {
    this.localData.checkVersionUpdate();
    //this.localData.remoteUpdateFormsAvailable();
    this.forms = this.localData.availableForms.filter((form) => form.publisher==this.publisher);
  }
  
  backToHomepage() {
    this.router.navigate(['/asb/home']);
  }


  async gotoForm(formobject){
    console.log('GOTO##', formobject.status, formobject);


    if(formobject.status=='completed'){

      let alert = await this.alertCtrl.create({
        header: 'Allerede indsendt',
        message: formobject.msgAlreadySubmitted,
        buttons: ['OK'],
      });
      await alert.present();

    }else if(formobject.status=='deadline exceeded'){

      let alert = await this.alertCtrl.create({
        header: 'Deadline overskrevet',
        message: formobject.msgDateOutOfRange,
        buttons: ['OK'],
      });
      await alert.present();

    }else if(formobject.isSoldOut){

      let alert = await this.alertCtrl.create({
        header: 'Udsolgt',
        message: formobject.soldOutMsg,
        buttons: ['OK'],
      });
      await alert.present();

    }else{

      let components = {
        'CultivationagreementPage': CultivationagreementPage,
        'RentalagreementPage': RentalagreementPage,
        'PrecampaignsubmissionPage': PrecampaignsubmissionPage,
        'RentalagreementCampaingPage': RentalagreementCampaingPage,
        'ProtamylasseorderPage': ProtamylasseorderPage,
        'PotatoseedorderPage': PotatoseedorderPage
      }
      

     
      let profileModal = await this.modalCtrl.create(
        {
          component:   components[formobject.component],
          componentProps: {
            formobject: formobject,
            modalCtrl: this.modalCtrl
          },
        });
        profileModal.present();
      
    }
  }



  ngOnInit() {
    this.subscription = this.route.params.subscribe(params => {
      
    if(params.publisher){
      this.publisher = params.publisher
    }
   
    //this.forms = this.localData.availableForms.filter((form) => form.publisher==this.publisher);
      
    });
  }
}